<template>
  <div class="contenedor">
    <div class="div-flotante" v-if="sesion != 'meditacion'">
      <b-button
        variant="primary"
        style="font-size: 20px"
        @click="showModal()"
        >{{ $t("messages.agendarSesion") }}</b-button
      >
    </div>
    <div
      class="container-div-flotante-in-title"
      style="width: 100%; height: 60px"
    >
      <span class="div-flotante-in-title"
        ><b-button
          variant="primary"
          style="font-size: 20px"
          @click="showModal()"
          >{{ $t("messages.agendarSesion") }}</b-button
        ></span
      >
    </div>

    <!-- tarot -->

    <div v-if="sesion === 'tarot'">
      <h1 class="title-vista">{{ $t("messages.tarotTitle") }}</h1>
      <p class="text-center font-weight-bold" style="font-size: 1.2rem; margin-top: 40px; margin-bottom: 50px;">
        {{ $t("messages.tarotSubtitle") }}
      </p>

      <p class="parrafo-justificado">
        {{ $t("messages.tarotDescription1") }}
      </p>

      <p class="parrafo-justificado">
        {{ $t("messages.tarotDescription2") }}
      </p>

      <p class="parrafo-justificado">
        {{ $t("messages.tarotDescription3") }}
      </p>

      <p class="parrafo-justificado" v-html="$i18n.locale === 'es' ? $t('messages.tarotDescription4').replace('resumen de integración', '<strong>resumen de integración</strong>') : $t('messages.tarotDescription4').replace('integration summary', '<strong>integration summary</strong>')">
      </p>

      <p class="mt-5 mb-3" style="text-align: left;">
        {{ $t("messages.tarotHelpingYou") }}
      </p>
      <ul class="mb-5">
        <li>{{ $t("messages.tarotBenefit1") }}</li>
        <li>{{ $t("messages.tarotBenefit2") }}</li>
        <li>{{ $t("messages.tarotBenefit3") }}</li>
        <li>{{ $t("messages.tarotBenefit4") }}</li>
        <li>{{ $t("messages.tarotBenefit5") }}</li>
      </ul>

      <p class="parrafo-justificado mb-5">
        {{ $t("messages.tarotClosing") }}
      </p>

      <h2 class="resalte m-0 mt-5">{{ $t("messages.energyExchange") }}</h2>
      <p class="resalteSoft">
        <span>{{ $t("messages.iAllowMyselfToGrow") }} — 55€</span>
        <span>{{ $t("messages.iHonorTheExchange") }} — 70€</span>
        <span>{{ $t("messages.iSustainAbundance") }} — 85€</span>
        
        <span class="mt-5" style="font-size: 1.1rem; font-weight: normal;">{{ $t("messages.disclimerPago") }}</span>
      </p>

      <p class="disclaime text-center mt-5" style="font-size: 1.2rem;">
        <strong>{{ $t("messages.confidencialidad") }}</strong>
      </p>
      <p class="disclaime text-center">
        {{ $t("messages.onlineExclusively") }}
      </p>
    </div>

    <!-- registros -->

    <!-- registros -->

    <div v-if="sesion === 'registros'">
      <h1 class="title-vista">{{ $t("messages.registrosTitle") }}</h1>
      
      <div v-if="$i18n.locale === 'es'">
        <p class="parrafo-justificado">
          Al abrir los Registros Akáshicos, accedemos a la memoria de tu alma, un campo de energía cuántica que contiene información sobre quién eres, quién has sido y quién puedes llegar a ser. Este espacio sagrado está protegido por guardianes espirituales —seres de luz, maestros ascendidos y ancestros— que brindan sabiduría y guía para ayudarte a ampliar tu perspectiva y tomar decisiones más conscientes.
        </p>
        <p class="parrafo-justificado font-weight-bold">
          Todos reencarnamos por un motivo y ese motivo está marcado en tu alma.
        </p>
        <p class="parrafo-justificado">
          La terapia de Registros Akáshicos permite comprender tu misión, lecciones de vida y procesos actuales. No se trata de adivinación, sino de una guía espiritual que te acompaña a explorar tu presente, comprender tu pasado y abrir posibilidades hacia el futuro.
        </p>
        <p class="parrafo-justificado">
          Con tu permiso, abriré tus Registros para responder a tus preguntas y ofrecerte orientación clara, amorosa y alineada a tu proceso. Antes de cada sesión, recibirás indicaciones para prepararte y así vivir la experiencia de forma más consciente y enriquecedora.
        </p>
        <p class="parrafo-justificado">
          Además, integro sanaciones energéticas a través de quirófanos de luz y asistencia espiritual, orientadas a generar equilibrio y bienestar a nivel físico, emocional, mental y espiritual. Estoy aquí para acompañarte en tu camino de transformación, brindándote claridad, contención y herramientas para avanzar con mayor confianza, paz y conexión.
        </p>
        <p class="parrafo-justificado text-center italic">
          ✨ Cuando vivimos desde el alma, la vida fluye con mayor armonía y propósito.
        </p>

        <h2 class="resalte m-0 mt-5">TIPOS DE SESIONES</h2>
        <p class="parrafo-justificado">
          Puedes elegir entre diferentes formas de trabajar con los Registros Akáshicos, según tu necesidad:
        </p>
        <ul>
          <li class="parrafo-justificado"><strong>Sesión de preguntas:</strong> Espacio personalizado donde podrás resolver inquietudes sobre tu vida actual. Todas las sesiones son grabadas y se entrega el audio posteriormente.</li>
          <li class="parrafo-justificado"><strong>Carta del alma:</strong> las características de tu alma: color de tu alma, animal de poder o espiritual, guía espiritual...</li>
          <li class="parrafo-justificado">Escaneo y equilibrio de chakras</li>
          <li class="parrafo-justificado">Carga, estabilización, sanación y protección del aura</li>
          <li class="parrafo-justificado">Limpieza energética de bienes y espacios físicos</li>
          <li class="parrafo-justificado">Manifestación consciente desde Akasha</li>
          <li class="parrafo-justificado">
            <strong>Sanaciones específicas:</strong> Dentro de las sesiones se incluyen sanaciones en las siguientes áreas:
            <ul>
              <li class="parrafo-justificado">Salud física y emocional</li>
              <li class="parrafo-justificado">Sanación del alma y de ancestros</li>
              <li class="parrafo-justificado">Niño interior y relaciones (incluyendo kármicas)</li>
              <li class="parrafo-justificado">Vidas pasadas</li>
              <li class="parrafo-justificado">Educación de niños y adolescentes</li>
              <li class="parrafo-justificado">Finanzas, camino laboral y realización personal</li>
              <li class="parrafo-justificado">Fertilidad y salud del útero</li>
              <li class="parrafo-justificado">Mascotas</li>
            </ul>
          </li>
        </ul>

        <h2 class="resalte m-0 mt-5">MODALIDADES DE SESIÓN</h2>
        <p class="parrafo-justificado">Cada sesión tiene una duración aproximada de 1 hora y 30 minutos y se realiza en total confidencialidad.</p>
        
        <div class="row mt-4">
          <div class="col-md-6 mb-3">
            <div class="modalidad-card">
              <h3>🔹 Modalidad Online</h3>
              <p class="resalteSoft m-0 p-0 text-left">
                <span>Sesión (solo audio) - {{ getMoneda }}30 USD</span>
                <span>Sesión (audio + resumen escrito) - {{ getMoneda }}35 USD</span>
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="modalidad-card">
              <h3>🔹 Modalidad Presencial</h3>
              <p class="resalteSoft m-0 p-0 text-left">
                <span>Sesión (solo audio) - {{ getMoneda }}40 USD</span>
                <span>Sesión (audio + resumen escrito) - {{ getMoneda }}45 USD</span>
              </p>
            </div>
          </div>
        </div>
        
        <p class="disclaime mt-5">
          * Si ninguna de estas opciones se adapta a ti, podemos valorar tu situación y encontrar la mejor forma de acompañarte.<br>
          * Servicio disponible actualmente en español.<br>
          * Para sesiones presenciales, consulta disponibilidad según tu ubicación.<br>
          * Todas las sesiones son estrictamente confidenciales.
        </p>
      </div>

      <div v-else>
        <p class="parrafo-justificado">
          By opening the Akashic Records, we access your soul's memory, a quantum energy field that contains information about who you are, who you've been, and who you can become. This sacred space is protected by spiritual guardians —light beings, ascended masters, and ancestors— who provide wisdom and guidance to help you expand your perspective and make more conscious decisions.
        </p>
        <p class="parrafo-justificado font-weight-bold">
          We all reincarnate for a reason, and that reason is imprinted on your soul.
        </p>
        <p class="parrafo-justificado">
          Akashic Records therapy allows you to understand your mission, life lessons, and current processes. It is not about divination, but rather a spiritual guide that accompanies you to explore your present, understand your past, and open possibilities for the future.
        </p>
        <p class="parrafo-justificado">
          With your permission, I will open your Records to answer your questions and offer you clear, loving guidance aligned with your process. Before each session, you will receive instructions to prepare yourself and thus experience it in a more conscious and enriching way.
        </p>
        <p class="parrafo-justificado">
          Additionally, I integrate energetic healings through light operating rooms and spiritual assistance, oriented towards generating balance and well-being at physical, emotional, mental, and spiritual levels. I am here to accompany you on your path of transformation, providing clarity, containment, and tools to move forward with greater confidence, peace, and connection.
        </p>
        <p class="parrafo-justificado text-center italic">
          ✨ When we live from the soul, life flows with greater harmony and purpose.
        </p>

        <h2 class="resalte m-0 mt-5">TYPES OF SESSIONS</h2>
        <p class="parrafo-justificado">
          You can choose between different ways of working with the Akashic Records, according to your needs:
        </p>
        <ul>
          <li class="parrafo-justificado"><strong>Question session:</strong> Personalized space where you can resolve concerns about your current life. All sessions are recorded and the audio is delivered afterwards.</li>
          <li class="parrafo-justificado"><strong>Soul letter:</strong> characteristics of your soul: soul color, power or spiritual animal, spiritual guide...</li>
          <li class="parrafo-justificado">Chakra scanning and balancing</li>
          <li class="parrafo-justificado">Charging, stabilization, healing, and protection of the aura</li>
          <li class="parrafo-justificado">Energetic cleansing of belongings and physical spaces</li>
          <li class="parrafo-justificado">Conscious manifestation from Akasha</li>
          <li class="parrafo-justificado">
            <strong>Specific healings:</strong> Sessions include healings in the following areas:
            <ul>
              <li class="parrafo-justificado">Physical and emotional health</li>
              <li class="parrafo-justificado">Soul and ancestor healing</li>
              <li class="parrafo-justificado">Inner child and relationships (including karmic)</li>
              <li class="parrafo-justificado">Past lives</li>
              <li class="parrafo-justificado">Education of children and teenagers</li>
              <li class="parrafo-justificado">Finances, labor path, and personal fulfillment</li>
              <li class="parrafo-justificado">Fertility and womb health</li>
              <li class="parrafo-justificado">Pets</li>
            </ul>
          </li>
        </ul>

        <h2 class="resalte m-0 mt-5">MODALITIES OF SESSION</h2>
        <p class="parrafo-justificado">Each session lasts approximately 1 hour and 30 minutes and is conducted in total confidentiality.</p>
        
        <div class="row mt-4">
          <div class="col-md-6 mb-3">
            <div class="modalidad-card">
              <h3>🔹 Online Modality</h3>
              <p class="resalteSoft m-0 p-0 text-left">
                <span>Session (audio only) - {{ getMoneda }}30 USD</span>
                <span>Session (audio + written summary) - {{ getMoneda }}35 USD</span>
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="modalidad-card">
              <h3>🔹 In-person Modality</h3>
              <p class="resalteSoft m-0 p-0 text-left">
                <span>Session (audio only) - {{ getMoneda }}40 USD</span>
                <span>Session (audio + written summary) - {{ getMoneda }}45 USD</span>
              </p>
            </div>
          </div>
        </div>
        
        <p class="disclaime mt-5">
          * If none of these options suit you, we can assess your situation and find the best way to support you.<br>
          * Service currently available in Spanish.<br>
          * For in-person sessions, check availability according to your location.<br>
          * All sessions are strictly confidential.
        </p>
      </div>
    </div>

    <!-- meditacion -->

    <div v-if="sesion === 'meditacion'">
      <h1 class="title-vista">{{ $t("messages.meditationTitle") }}</h1>
      <p class="parrafo-justificado" v-html="formattedTextFirstPart"></p>
      <p class="parrafo-justificado">
        <cite>
          {{
            $i18n.locale === "en"
              ? "“Meditation refers to a family of techniques which have in common a conscious attempt to focus attention in a non-analytical way and an attempt not to dwell on discursive, ruminating thought.” (Shapiro, 1982)"
              : "“La meditación se refiere a una familia de técnicas que tienen en común un intento consciente de centrar la atención de una manera no analítica y un intento de no detenerse en el pensamiento discursivo y rumiante” (Shapiro, 1982)"
          }}
        </cite>
      </p>
      <p class="parrafo-justificado">
        <cite>
          {{
            $i18n.locale === "en"
              ? "“A universal theology is impossible, but a universal experience is not only possible but necessary.” - A Course In Miracles"
              : "“Una teología universal es imposible, mientras que una experiencia universal no sólo es posible sino necesaria.” - Un Curso de Milagros"
          }}
        </cite>
      </p>
      <div
        class="descripcion-detalle"
        v-for="(descarga, index) in descargas.filter(
          (item) => item.titulo[$i18n.locale]
        )"
        :key="index"
      >
        <h2 style="color: white">
          {{ descarga.titulo[$i18n.locale] }}
        </h2>
        <p
          class="parrafo-justificado text-meditacion"
          style="color: white"
          v-for="(parrafo, index2) in descarga.parrafos[$i18n.locale]"
          :key="index2"
        >
          {{ parrafo }}
        </p>
        <a
          :href="`../../assets/sounds/${descarga.fichero[$i18n.locale]}`"
          :download="descarga.fichero[$i18n.locale]"
        >
          <h3 class="link-audio">
            <b-icon icon="download" scale="1" class="ml-3 mr-3"></b-icon
            >{{ descarga.descargaTitulo[$i18n.locale] }}
          </h3>
        </a>
      </div>

      <!-- <div class="descripcion-detalle">
        <h2 style="color: white">
          {{
            $i18n.locale === "en"
              ? "Unconditional Love Meditation"
              : "Meditación del amor incondicional"
          }}
        </h2>
        <p class="parrafo-justificado" style="color: white">
          {{
            $i18n.locale === "en"
              ? "The Metta Bhavana meditation, also known as the Unconditional Love Meditation, originates from ancient India and is derived from the Pali language. The term “metta” can be translated to “loving-kindness” or “unconditional love”, referring to pure love that extends beyond romantic love to include all living beings. “Bhavana” translates to “cultivate” or “develop”"
              : "La meditación Metta Bhavana, también conocida como Meditación del Amor Incondicional, tiene su origen en la antigua India y proviene del idioma Pali. El término “metta” se puede traducir como “amor bondadoso” o “amor incondicional”, refiriéndose a un amor puro que se extiende más allá del amor romántico e incluye a todos los seres vivos. “Bhavana” se traduce como “cultivar” o “desarrollar”."
          }}
        </p>
        <p class="parrafo-justificado" style="color: white">
          {{
            $i18n.locale === "en"
              ? "This meditation is different from mindfulness meditation in that it has a specific goal, which is to cultivate loving-kindness and feel love for oneself and others. It involves reprogramming one's emotions to be more love-based, rather than just observing the mind without judgment. Practicing this meditation raises one's awareness of their automatic emotional state, which may include judgment or resentment. By practicing this meditation, one can make the decision to achieve a higher state of consciousness and attain happiness."
              : "Esta meditación difiere de la meditación “mindfulness” en que tiene un objetivo específico, que es cultivar el amor bondadoso y sentir amor por uno mismo y por los demás. Implica reprogramar las emociones para que estén basadas en el amor, en lugar de simplemente observar la mente sin juzgar. Practicando esta meditación, se aumenta la conciencia del propio estado emocional automático, que puede incluir juicio o resentimiento. Al practicar esta meditación, puedes tomar la decisión de alcanzar un estado superior de consciencia y alcanzar la felicidad."
          }}
        </p>
        <h3 @click="downloadAudio()" class="link-audio">
          <b-icon icon="download" scale="1" class="ml-3 mr-3"></b-icon
          >{{ $t("messages.download") }}
        </h3>
      </div> -->
      <!-- <p class="resalteSoft">
        Donación XXXXX Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Cupiditate aliquid laudantium in tempora dolorem
      </p> -->
    </div>
    <modal-add-cite-of-session
      :show="showModalAdd"
      :tiposSession="tiposSession"
      :sesionistas="sesionistas"
      :husoHorarios="husoHorarios"
      :sesionistasTipoSesion="sesionistasTipoSesion"
      :disponibilidadSesionistas="disponibilidadSesionistas"
      @ok="cerrarModal()"
      @cancel="cerrarModal()"
    />
  </div>
</template>

<script>
import ModalAddCiteOfSession from "@/components/PublicComponents/ModalAddCiteOfSession.vue";
import SesionesService from "@/services/sesiones.service.js";
import EventBus from "@/services/eventBus.js";
import { mapGetters } from "vuex";
export default {
  name: "SesionDetail",
  components: { "modal-add-cite-of-session": ModalAddCiteOfSession },
  data() {
    return {
      sesion: "",
      sesionesPosibles: ["tarot", "registros", "meditacion"],
      showModalAdd: false,
      sessionesService: new SesionesService(),
      tiposSession: [],
      sesionistas: [],
      husoHorarios: [],
      sesionistasTipoSesion: [],
      disponibilidadSesionistas: [],
      descargas: [],
    };
  },
  mounted() {
    this.sesion = this.$route.params.sesion.toLowerCase();
    if (!this.sesionesPosibles.includes(this.sesion)) {
      this.$router.push({ name: "Home" });
    }
    this.getDescargas();
    this.getTipoSesiones();
    this.getSesionistas();
    this.getSesionistasTipoDeSesion();
    if (this.getToken) {
      this.getHusoHorarios();
      this.getDisponibilidadSesionistas();
    }
    window.scrollTo(0, 0);
  },
  watch: {
    $route(to, from) {
      this.sesion = to.params.sesion.toLowerCase();
      if (!this.sesionesPosibles.includes(this.sesion)) {
        this.$router.push({ name: "Home" });
      }
    },
    getToken() {
      if (this.getToken) {
        this.getTipoSesiones();
        this.getSesionistas();
        this.getHusoHorarios();
        this.getSesionistasTipoDeSesion();
        this.getDisponibilidadSesionistas();
      }
    },
    sesion() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    getDescargas() {
      this.descargas = require(`@/assets/data/descargas.json`);
    },
    cerrarModal() {
      this.showModalAdd = false;
    },
    showModal() {
      if (!this.getToken) {
        EventBus.$emit("MOSTRAR_TOAST", {
          title: "Error",
          variant: "warning",
          message:  this.$t("messages.mustBeLogin"),
        });
        return;
      }
      this.showModalAdd = true;
    },
    getTipoSesiones() {
      this.sessionesService
        .getTipoSesiones()
        .then((response) => {
          this.tiposSession = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSesionistas() {
      this.sessionesService
        .getSesionistas()
        .then((response) => {
          this.sesionistas = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getHusoHorarios() {
      this.sessionesService
        .getHusoHorarios()
        .then((response) => {
          this.husoHorarios = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSesionistasTipoDeSesion() {
      this.sessionesService
        .getSesionistasTipoSesion()
        .then((response) => {
          this.sesionistasTipoSesion = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getDisponibilidadSesionistas() {
      this.sessionesService
        .getDisponibilidadSesionistas()
        .then((response) => {
          this.disponibilidadSesionistas = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
    getWidth() {
      return window.innerWidth;
    },
    getMoneda() {
      const zona = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return zona.includes("London")
        ? "£"
        : zona.includes("Europe")
        ? "€"
        : "$";
    },
    idiomas() {
      if (this.sesionistas.length === 0) return "";

      const sesionActual = this.tiposSession.find((tipoSesion) => {
        return tipoSesion.codigo === this.sesion;
      });

      if (!sesionActual) return "";

      const sesionistasEnEsaSesion = this.sesionistasTipoSesion.filter(
        (sesionistasTipoSesion) =>
          sesionistasTipoSesion.id_tipo_sesion === sesionActual.id
      );

      const getIdSesionistasNoRepeat = [
        ...new Set(
          sesionistasEnEsaSesion.map((sesionista) => sesionista.id_sesionista)
        ),
      ];

      const getIdiomas = this.sesionistas
        .filter((sesionista) =>
          getIdSesionistasNoRepeat.includes(sesionista.id)
        )
        .map((sesionista) => sesionista.idiomas.split(","));

      let idiomaArrayPlain = getIdiomas.flat();
      let idiomasTraducidos = idiomaArrayPlain.map((idioma) => {
        return (
          this.$t(`messages.${idioma}`).charAt(0).toUpperCase() +
          this.$t(`messages.${idioma}`).slice(1)
        );
      });

      return idiomasTraducidos.join(", ");
    },
    formattedTextFirstPart() {
      return this.$i18n.locale === "en"
        ? `All of our experiences occur in the present moment. However, we often become consumed by worries about the future or sadness about the past, mistakenly believing that these thoughts and feelings define us. We may listen incessantly to the inner dialogue in our minds or be overwhelmed by our emotions, which prevents us from recognizing our true nature as beings of light and love.
            <br><br>
            There are different meditation techniques that help us connect with our true nature. Some meditation techniques will ask you to move and be active. Others will ask you to stay in a quiet and still place. There are also meditation techniques where you are asked to focus on your emotions and thoughts, and others that ask you to detach from them. The diversity of techniques is like life itself, with a great multitude of forms. This makes meditation very interesting and adaptable to your preferences.
            <br><br>
            It is very important not to give up and instead find your way of meditating. The benefits of meditation are key to living in the present and to having a harmonious, fulfilling, and free-from-negative programming (limiting beliefs) life.
            <br><br>
            All techniques are good, and you will choose the one that is most suitable for you. As long as the practice is a conscious attempt to focus your attention on a particular object and do so in a non-analytical way, you can have that wonderful experience of the present moment.`
        : `Todas nuestras experiencias ocurren en el momento presente. Sin embargo, a menudo nos dejamos consumir por preocupaciones sobre el futuro o tristezas por el pasado, creyendo erróneamente que estos pensamientos y sentimientos nos definen. Podemos escuchar sin descanso el diálogo interno en nuestras mentes o ser abrumados por nuestras emociones, lo que nos impide reconocer nuestra verdadera naturaleza como seres de luz y amor.
            <br><br>
            Existen distintas técnicas de meditación que nos ayudan a conectarnos con nuestra verdadera naturaleza. Algunas técnicas de meditación te pedirán moverte y estar activo. Otras, en cambio, te pedirán quedarte en un lugar tranquilo y quieto. También existen técnicas de meditación en las cuales se te pedirá centrarte en tus emociones y pensamientos, y otras que te pedirán lo contrario, desapegarte de ellos. La diversidad de técnicas es como la vida misma, con una gran multitud de formas. Este hecho hace a la meditación muy interesante y adaptable a tus preferencias.
            <br><br>
            Es muy importante no rendirse y, en cambio, buscar tu forma de hacer meditación. Los beneficios de la meditación son clave para vivir en el presente y para tener una vida en armonía, plena y libre de programaciones negativas (creencias limitantes).
            <br><br>
            Todas las técnicas son buenas, y tú elegirás cuál es la más adecuada para ti. Siempre que la práctica sea un intento consciente de focalizar tu atención en un objeto en particular y hacerlo de una manera no analítica, podrás tener esa experiencia maravillosa del momento presente.`;
    }
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  padding: 50px 300px;
  width: 100%;
}

p {
  font-size: 1.4rem;
  margin-top: 50px;
  text-align: left;
}

cite {
  font-size: 1.5rem;
  font-weight: bold;
}

.resalte {
  font-size: 1.7rem;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 30px;
  color: #eb1090;
  text-align: center;
}

.resalteSoft {
  display: flex;
  flex-direction: column;
  font-size: 1.3rem;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 30px;
  text-align: center;
  //last child
  span:last-child {
    margin-top: 30px;
  }
}

li {
  font-size: 1.4rem;
  text-align: left;
}

.link-audio {
  cursor: pointer;
  color: var(--primary-misty-oracle);
  transition: 0.5s all;
  margin-top: 50px;
}

.link-audio:hover {
  color: white;
  text-shadow: 0px 0px 10px var(--primary-misty-oracle);
  letter-spacing: 1px;
}

.div-flotante {
  position: fixed;
  bottom: 50%;
  right: 0;
  margin: 20px;
  z-index: 100;
}

.div-flotante-in-title {
  float: right;
  display: none;
}
.descripcion-detalle {
  background-color: #0b0144;
  color: white;
  padding: 54px;
  border: 4px solid #eb1090;
  margin-top: 67px;
}

h2 {
  font-size: 2.5vw;
}

.container-div-flotante-in-title {
  display: none;
}

.disclaime {
  font-size: 1rem;
  letter-spacing: 1.2px;
}

.parrafo-justificado {
  text-align: justify;
}

.modalidad-card {
  background-color: #f9f5fb;
  border-left: 4px solid var(--primary-misty-oracle);
  padding: 25px 30px;
  margin: 10px 0;
  border-radius: 6px;
  height: 100%;
  h3 {
    font-size: 1.4rem;
    color: var(--primary-misty-oracle);
    margin-bottom: 30px;
    text-align: center;
  }
}

@media screen and (max-width: 1100px) {
  .div-flotante {
    display: none;
  }

  .container-div-flotante-in-title {
    display: block;
  }

  .div-flotante-in-title {
    display: block;
  }
  .contenedor {
    padding: 50px 15px;
  }

  .title {
    font-size: 6vw !important;
  }

  p {
    font-size: 1.2rem;
    margin-top: 30px;
  }

  li {
    font-size: 1.2rem;
  }

  cite {
    font-size: 1.3rem;
  }

  .resalte {
    font-size: 1.5rem;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .resalteSoft {
    font-size: 1.5rem;
  }

  .descripcion-detalle {
    background-color: #0b0144;
    color: white;
    padding: 10px;
    border: 4px solid #eb1090;
    margin-top: 67px;
    h2 {
      font-size: 5vw;
    }
  }
}

@media screen and (max-width: 500px) {
  .title {
    font-size: 10vw !important;
  }

  .descripcion-detalle {
    h2 {
      font-size: 8vw;
    }
  }
  
  .text-meditacion{
    font-size: 1.1rem;
    line-height: 1.3rem;
  }
}
</style>
